<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      d="M18 3C17.6844 3 17.4029 3.14621 17.2197 3.3746L13.3237 7.27053L13.2405 7.36474C12.9355 7.75703 12.9632 8.32426 13.3237 8.68475L13.4179 8.76793C13.8102 9.07296 14.3774 9.04523 14.7379 8.68475L17 6.42219V19L17.0067 19.1166C17.0645 19.614 17.4872 20 18 20C18.5523 20 19 19.5523 19 19V6.40594L21.3014 8.70711L21.3956 8.7903C21.7879 9.09532 22.3551 9.06759 22.7156 8.70711C23.1061 8.31658 23.1061 7.68342 22.7156 7.29289L18.7156 3.29289L18.6214 3.2097C18.4404 3.06899 18.2222 2.9991 18.0042 3.00001L18 3Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M2 16.4C2 15.6268 2.6268 15 3.4 15H5.1C5.8732 15 6.5 15.6268 6.5 16.4V18.1C6.5 18.8732 5.8732 19.5 5.1 19.5H3.4C2.6268 19.5 2 18.8732 2 18.1V16.4ZM3.6 17.9V16.6H4.9V17.9H3.6Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M8.9 15C8.1268 15 7.5 15.6268 7.5 16.4V18.1C7.5 18.8732 8.1268 19.5 8.9 19.5H10.6C11.3732 19.5 12 18.8732 12 18.1V16.4C12 15.6268 11.3732 15 10.6 15H8.9ZM9.1 16.6V17.9H10.4V16.6H9.1Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V12C12 13.1046 11.1046 14 10 14H4C2.89543 14 2 13.1046 2 12V6ZM4 6H10V12H4L4 6Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
